import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/Services/Auth/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActiveCampaignService } from 'src/app/Services/ActiveCampaign.service';



@Component({
  selector: 'app-signup2',
  templateUrl: './SignUp2.component.html',
  styleUrls: ['./SignUp2.component.scss']
})
export class Signup2Component implements OnInit {
  public form: FormGroup;
  emailPattern = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';
  loading = false;
  showRegisterError = false;
  registerErrorMessage = 'There was an error on register';
  videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/404642466');
  planId=null;
  token_pay=null;
  plan_id=null;
  discountCode='';
  constructor(private fb: FormBuilder, private router: Router, private authService: AuthService,
    public sanitizer: DomSanitizer,private aC: ActiveCampaignService, private route:ActivatedRoute) { }

  ngOnInit() {
    this.form = this.fb.group(
      {
        firstName: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
        isChecked:[]
      },
      {
        validator: this.MatchPassword // your validation method
      }
    );
    this.planId= this.route.snapshot.queryParamMap.get('idplan');
    this.discountCode=this.route.snapshot.queryParamMap.get('disc');
    this.token_pay=this.route.snapshot.queryParamMap.get('token_pay');
    this.plan_id=this.route.snapshot.queryParamMap.get('plan_id');
    
    
  }

  /*
   * Match Password Custom validation
   */
  MatchPassword(AC: AbstractControl) {
    const password = AC.get('newPassword').value; // to get value in input tag
    const confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password != confirmPassword) {
      AC.get('confirmPassword').setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  async signUp() {
    
    if (this.form.valid) {
      this.loading = true;
      const nameArray = this.form.get('firstName').value.trim().split(' ');
      if (nameArray.length < 2) {
        this.loading = false;
        return this.form.controls['firstName'].setErrors({fullNameRequired: true});
      } else {
        if (!this.form.get('isChecked').value){
          this.loading = false;
          return this.form.controls['isChecked'].setErrors({check: true});
        }
        let firstNames = '';
        let lastName = '';
        nameArray.map((name, i) => {
          if (i != nameArray.length - 1) {
            firstNames = firstNames.concat(name + ' ');
          } else {
            lastName = name;
          }
        });
        try {
          if (this.plan_id&&this.token_pay){
            await this.authService.registerWithPlan(firstNames, lastName, this.form.get('email').value, this.form.get('newPassword').value,this.plan_id,this.token_pay);

          }else{
            await this.authService.register(firstNames, lastName, this.form.get('email').value, this.form.get('newPassword').value);

          }
          await this.aC.registerContact(firstNames,lastName,this.form.get('email').value);
   
          this.loading = false;
          if (!this.planId){
            return window.location.href = '/home';
           // return window.location.href = 'logged/profile?section=plans';
            
          }else{
            let code=''
            if (this.discountCode!='') {
              code='&&code='+this.discountCode;
            }
            return window.location.href = 'logged/profile/payment?plan='+this.planId+code;
          }
        } catch (error) {
          this.loading = false;
          this.showRegisterError = true;
          if (error.error.errors['email']) {
            this.registerErrorMessage = error.error.errors['email'][0];
          }
        }
      }
    } else {
      this.loading = false;
      for (let i in this.form.controls) {
        this.form.controls[i].markAsTouched();
      }
    }
  }
}
